(function(){
    'use strict';
    
    angular.module("Directives").directive("trackingEvents", trackingEvents);
    trackingEvents.$inject = [];

    function trackingEvents(){
        return {
            'restrict': 'E',
            'templateUrl': '/templates/directives/tracking-events.html',
            'scope': {
                eventsData: '='
            },
            link: function trackingEvents($scope, element, attrs) {
                $scope.$watch('eventsData', function(eventsData){
                    $scope.events = eventsData.data;
                });
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/directives/trackingEvents.js